export interface SocialSecurityStatus {
	id: number;
	remark?: string;
	initial?: string;
	guid: string;
	statusActivity: SocialSecurityStatusActivity;
}

export enum SocialSecurityStatusActivity {
	UNKNOWN = 0,
	J = 1,
	j = 2,
	N = 3,
	S = 4,
}
